import cx from 'classnames'
import { Icon, Button, Table, Tag, Modal, H4, P } from '@driftt/tide-core-legacy'


import './style.styl'


const getWhitelabelData = (whitelabel) => {
  if (!!whitelabel.get('sparkPostDkim') && !!whitelabel.get('sendgridDkim')) {
    return whitelabel.get('sendgridDkim').dNSRecords.concat(whitelabel.get('sparkPostDkim').dNSRecords).map(makeDomainTableRow)
  }
  if (!!whitelabel.get('sparkPostDkim')) {
    return whitelabel.get('sparkPostDkim').dNSRecords.map(makeDomainTableRow)
  }
  if (!!whitelabel.get('sendgridDkim')) {
    return whitelabel.get('sendgridDkim').dNSRecords.map(makeDomainTableRow)
  }
}

const makeDomainTableRow = (dnsEntry) => ({
  data: [
    { content: dnsEntry.type, className: `dkim-table-row-record-type ${dnsEntry.valid ? 'dkim-table-row-valid-status' : 'dkim-table-row-invalid-status'}` },
    { content: dnsEntry.host, className: 'dkim-table-row-dns-host' },
    { content: dnsEntry.data, className: 'dkim-table-row-dns-required-data' },
    { content: dnsEntry.valid ? 'Record found' : 'Record not found', className: `dkim-table-row-status ${dnsEntry.valid ? 'dkim-table-row-valid-status' : 'dkim-table-row-invalid-status'}` },
  ]
})

const WhiteLabelDomainTable = ({
  whitelabel,
  onVerifyClick,
  verifyPending,
  verifyFailed,
  verifySuccess,
  toggleDeleteModal
}) => (
  <div className="dkim-domain-content">
    <div className="dkim-domain-table-header">
      <H4>Your DNS settings</H4>
      <P>This table shows you the DNS entries needed to connect your domain to Drift email. Log in to your domain provider to manage these settings. <a href="https://help.drift.com/article/email-sending-domains/">Learn more</a></P>
    </div>
    <div>
      <Table
        columns={[{ label: 'RECORD' }, { label: 'HOST' }, { label: 'REQUIRED DATA' }, { label: 'STATUS' }]}
          data={getWhitelabelData(whitelabel)}
    />
      <div className="dkim-domain-verify-container">
        <p className={cx('dkim-domain-verify-helptext', { 'dkim-domain-verify-fail': verifyFailed, 'dkim-domain-verify-success': verifySuccess })}>
          {verifyFailed && 'Could not validate your domains.'}
          {verifySuccess && 'Domains successfully verified!'}
        </p>
        <Button loading={verifyPending} disabled={verifyPending} type="primary" onClick={onVerifyClick}>Verify DNS Settings</Button>  
        <Button className="dkim-domain-delete" type="tertiary" onClick={toggleDeleteModal}>Delete sending domain</Button>        
      </div>
    </div>
  </div>
)


const Domain = ({
  isOpen,
  whitelabel,
  isVerified,
  toggleActive,
  onVerifyClick,
  verifyPending,
  verifyFailed,
  verifySuccess,
  onDeleteClick,
  isDeletingDomain,
  toggleDeleteModal
}) => (
  <div className={cx('dkim-domain-container', { 'dkim-domain-container-active': isOpen })}>
    <div className={cx('dkim-domain-entry', { 'dkim-domain-entry-active': isOpen })} onClick={toggleActive}>
      <div className="dkim-domain-entry-title">
        <span className={cx('dkim-domain-entry-status-dot', { 'dkim-domain-entry-enabled': isVerified })}></span>
        <H4 className={cx("dkim-domain-entry-name", { 'dkim-domain-entry-name-disabled': !isVerified })} >{whitelabel.get('domain')}</H4>
      </div>
      <div className="dkim-domain-entry-title">
        <Tag
          text={isVerified ? 'Verified' : 'Needs Verification'}
          wrapperClass={`dkim-domain-entry-status-text ${isVerified ? 'dkim-domain-entry-status-verified' : 'dkim-domain-entry-status-not-verified'}`}
          textClass={isVerified ? 'dkim-domain-entry-status-text-verified' : 'dkim-domain-entry-status-text-not-verified'}
        />
        <Icon name="chevron-down" className={cx('dkim-domain-entry-caret', { ['dkim-domain-entry-caret-active']: isOpen })}/>
      </div>
    </div>
    {isOpen &&
      <WhiteLabelDomainTable
        whitelabel={whitelabel}
        onVerifyClick={onVerifyClick}
        verifyPending={verifyPending}
        verifyFailed={verifyFailed}
        verifySuccess={verifySuccess}
        toggleDeleteModal={toggleDeleteModal}
      />
    }
    {isDeletingDomain &&
      <Modal
        open={isDeletingDomain}
        size="small"
        type="warning"
        onClose={toggleDeleteModal}
        title="Deleting Sending Domain"
        className="dkim-delete-modal-wrapper"
      >
      <div className="dkim-delete-modal-content">
        Are you sure you want to delete {whitelabel.get('domain')}?
      </div>
        <footer>
          <Button type="secondary" onClick={onDeleteClick}>Delete</Button>
          <Button type="subtle" onClick={toggleDeleteModal}>Cancel</Button>
        </footer>
      </Modal>
    }
  </div>
)


export default Domain



// WEBPACK FOOTER //
// ./src/scripts/components/settings/DKIMEmailSettings/Domain/component.js